import AggregateDashboardComponent from "../../../components/Dashboards/Operations/agregateDashboard";
import { useParams } from "react-router-dom";
function AggregateSiteDashboardPage() {
  const { id } = useParams();
  return <AggregateDashboardComponent level_id={id as string} />;
}

export default AggregateSiteDashboardPage;
